var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',_vm._b({ref:"combobox",attrs:{"items":_vm.items},on:{"change":_vm.onChange},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-combobox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }